import { ViewBasic } from "@quatrecentquatre/manage-me";
import { bindAll } from "underscore";

export class Reservation extends ViewBasic {
    constructor(options) {
        super(options);
    }

    initialize() {
        bindAll(this, ["openPopup"]);

        this.addEvents();
        let scope = this;
        this.popup_id = "overlay-restaurant";
        this.popup_type = "reservation";
        if (this.el.querySelector(".primary-cta").dataset.restaurant) {
            this.popup_id = "overlay-reservation";
            this.popup_type = "";
        }
        setTimeout(function () {
            window.dispatchEvent(
                new CustomEvent("Overlay.open", {
                    detail: {
                        id: scope.popup_id,
                        type: scope.popup_type,
                    },
                }),
            );
        }, 100);
    }

    addEvents() {
        this.el.querySelector(".primary-cta").addEventListener("click", this.openPopup);
    }

    removeEvents() {
        this.el.querySelector(".primary-cta").removeEventListener("click", this.openPopup);
    }

    openPopup() {
        let scope = this;
        window.dispatchEvent(
            new CustomEvent("Overlay.open", {
                detail: {
                    id: scope.popup_id,
                },
            }),
        );
    }
}

Me.views["Reservation"] = Reservation;
